module.exports = __webpack_public_path__ + "static/img/training_system_hy_s5_1.8bf07d83.png";